import React from "react";
import Icon from "./icon";

export default function Availability({ className, icon, children, testRefs }) {
  return (
    <div className={className} {...testRefs}>
      {icon ? <Icon name={icon} /> : null}
      {children}
    </div>
  );
}
